import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import {
  arrayPush,
  FormSection,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import validate from "./formBuilderValidation"
import {
  addFormBuilder,
  cloneMenuFeature,
  getFeatureRecipients,
  getFormBuilder,
  getFormBuilderList,
  hideLockWarningModal,
  resetFeatureRecipients,
  resetFormBuilder,
  updateFormBuilder,
} from "store/actions"
import {
  CloneFeatureModal,
  mapApiToFormBuilder,
  mapFormBuilderToApi,
} from "../utils"
import PropTypes from "prop-types"
import QuestionsTab from "./questionsTab"
import Payouts from "containers/Payouts"
import ResponsesTab from "./responsesTab"
import MenuFeatureHyperlinks from "../menuFeatureHyperlinks"
import { getPollsAxios } from "helpers/api_helper"
import ModalComponent from "components/Modals"
import { SaveButton } from "components/Buttons"
import { LoadingIndicator } from "components/LoadingIndicator"

let FormBuilder = props => {
  const TABS = {
    QUESTIONS: 1,
    RESPONSES: 2,
    PAYOUTS: 3,
    HYPERLINKS: 4,
  }
  const [activeTab, setActiveTab] = useState(TABS.QUESTIONS)
  const [hasReplies, setHasReplies] = useState(false)

  const markAsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    const getHasReplies = async () => {
      try {
        const { has_replies } = await getPollsAxios(
          `/form-builder/${props.feature.entity_id}/has-replies`
        )
        setHasReplies(has_replies)
      } catch (error) {
        console.error(error)
      }
    }

    if (props.feature.entity_id) {
      getHasReplies()
      props.getFormBuilder(props.feature.entity_id)
      props.getFeatureRecipients({
        feature_id: props?.feature?.entity_id,
        feature_type: "form_builder",
      })
    }

    return () => {
      props.resetFormBuilder()
      props.resetFeatureRecipients()
    }
  }, [])

  useEffect(() => {
    if (props.formBuilder && props?.featureRecipients) {
      const { formData, responses } = mapApiToFormBuilder({
        form: props.formBuilder,
        featureRecipients: props.featureRecipients,
      })
      props.initializeForm({ ...formData, responses })
    }
  }, [props.formBuilder, props?.featureRecipients])

  const handleFormBuilderSubmit = data => {
    const [questions, params] = mapFormBuilderToApi({
      ...data.form_builder_form,
      vendor_id: props.vendorId,
      user_id: props.userId,
      name: props.feature.label,
      status: props.feature.status ? 1 : 0,
      menu_feature: 1,
      menu_item_id: props.feature.id,
      order: 0,
      event_id: props.selectedEvent ? props.selectedEvent?.id : null,
    })
    if (!props.formBuilder) {
      props.addFormBuilder(questions, params)
    } else {
      props.updateFormBuilder(questions, params, props.feature.entity_id)
    }
  }

  return (
    <React.Fragment>
      {props?.formBuilderLoading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm p-1">
            <Nav tabs pills>
              <NavLink
                className={markAsActive(TABS.QUESTIONS)}
                onClick={() => setActiveTab(TABS.QUESTIONS)}
              >
                Questions
              </NavLink>
              <NavLink
                className={markAsActive(TABS.RESPONSES)}
                onClick={() => setActiveTab(TABS.RESPONSES)}
              >
                Responses
              </NavLink>
              {/* {props?.requirePayment && (
              <NavLink
                className={markAsActive(TABS.PAYOUTS)}
                onClick={() => setActiveTab(TABS.PAYOUTS)}
              >
                Payouts
              </NavLink>
            )} */}
              {props?.isEventFeature &&
                !props?.isListItem &&
                (!!props?.vendorConfig?.nfc_hyperlinks ||
                  !!props?.vendorConfig?.communication_hyperlinks) && (
                  <NavLink
                    className={markAsActive(TABS.HYPERLINKS)}
                    onClick={() => setActiveTab(TABS.HYPERLINKS)}
                  >
                    Hyperlinks
                  </NavLink>
                )}
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={TABS.QUESTIONS} style={{ animation: "none" }}>
                <FormSection name={`${props.form}`}>
                  <QuestionsTab
                    feature={props.feature}
                    handleAddListItem={props.handleAddListItem}
                    isListItem={props.isListItem}
                    backButtonHandler={props.backButtonHandler}
                    design={props.design}
                    handleSave={
                      props.isListItem
                        ? props.handleSubmit(props.handleAddListItem)
                        : props.handleSubmit(handleFormBuilderSubmit)
                    }
                    hasReplies={hasReplies}
                  />
                </FormSection>
              </TabPane>
              <TabPane tabId={TABS.RESPONSES} style={{ animation: "none" }}>
                <FormSection name={`${props.form}.responses`}>
                  <ResponsesTab feature={props.feature} />
                </FormSection>
              </TabPane>
              {/* <TabPane tabId={TABS.PAYOUTS} style={{ animation: "none" }}>
              <Card>
                <CardBody>
                  <Payouts
                    entity_id={props.feature.entity_id}
                    entity_type="form_builder"
                    menu_item_id={props.feature.id}
                    price={props?.price}
                  />
                </CardBody>
              </Card>
            </TabPane> */}
              {props?.isEventFeature &&
                !props?.isListItem &&
                (!!props?.vendorConfig?.nfc_hyperlinks ||
                  !!props?.vendorConfig?.communication_hyperlinks) && (
                  <TabPane
                    tabId={TABS.HYPERLINKS}
                    style={{ animation: "none" }}
                  >
                    <MenuFeatureHyperlinks
                      event_id={props?.selectedEvent?.id}
                      menu_feature={props?.feature}
                    />
                  </TabPane>
                )}
            </TabContent>
          </CardBody>
        </Card>
      )}
      <ModalComponent
        title={`Clone Form Menu Feature`}
        open={props.lockWarningModalIsOpen}
        onClose={props.hideLockWarningModal}
        returnFocusAfterClose={false}
      >
        <CloneFeatureModal
          handleClone={() => {
            props?.cloneMenuFeature({
              data: {
                vendor_id: +props?.vendorId,
                entity_type: "form_builder",
                entity_id: props?.formBuilder?.id,
                menu_item_id: props?.formBuilder?.menu_item_id,
              },
              callback: props?.isListItem
                ? () => {
                    props.getFormBuilderList({
                      menu_item_id: props.formBuilder?.menu_item_id,
                      vendor_id: parseInt(props.vendorId),
                      ...(!!props?.selectedEvent
                        ? { event_id: props.selectedEvent.id }
                        : {}),
                    })
                  }
                : null,
            })
          }}
          handleCloseModal={props.hideLockWarningModal}
          featureName={"Form"}
          loading={props?.loading}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

FormBuilder = reduxForm({
  form: FORM_NAMES.FORM_BUILDER,
  initialValues: {
    form_builder_form: {
      includeResponses: true,
      questions: [
        {
          answerType: "1",
          answers: [
            { id: null, answer: "" },
            { id: null, answer: "" },
          ],
          textAnswerType: "1",
          id: null,
        },
      ],
    },
  },
  validate,
})(FormBuilder)

const selector = formValueSelector(FORM_NAMES.FORM_BUILDER)

const mapStateToProps = state => ({
  retake: selector(state, "form_builder_form.retake"),
  questions: selector(state, "form_builder_form.questions"),
  answerType: selector(state, "form_builder_form.answerType"),
  formBuilder: state.FormBuilder.formBuilder,
  formBuilderLoading: state.FormBuilder.formBuilderLoading,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  selectedEvent: state.experiences.selectedEvent,
  formValues: selector(state, "form_builder_form"),
  requirePayment: selector(state, "form_builder_form.requirePayment"),
  price: selector(state, "form_builder_form.price"),
  vendorConfig: state.clients.vendorConfig,
  lockWarningModalIsOpen: state.menuFeatures.lockWarningModalIsOpen,
  loading: state.menuFeatures.loading,
  featureRecipients: state.ProductsAndSubscriptions.featureRecipients,
})

const mapDispatchToProps = dispatch => ({
  addForm: (form, field, values) => dispatch(arrayPush(form, field, values)),
  getFormBuilder: values => dispatch(getFormBuilder(values)),
  resetFormBuilder: () => dispatch(resetFormBuilder()),
  initializeForm: values =>
    dispatch(
      initialize(FORM_NAMES.FORM_BUILDER, {
        form_builder_form: values,
      })
    ),
  addFormBuilder: (questions, params) =>
    dispatch(addFormBuilder(questions, params)),
  updateFormBuilder: (questions, params, entity_id) =>
    dispatch(updateFormBuilder(questions, params, entity_id)),
  cloneMenuFeature: values => dispatch(cloneMenuFeature(values)),
  hideLockWarningModal: () => dispatch(hideLockWarningModal()),
  getFormBuilderList: values => dispatch(getFormBuilderList(values)),
  getFeatureRecipients: values => dispatch(getFeatureRecipients(values)),
  resetFeatureRecipients: () => dispatch(resetFeatureRecipients()),
})

FormBuilder.propTypes = {
  feature: PropTypes.object,
  handleAddListItem: PropTypes.func,
  isListItem: PropTypes.bool,
  backButtonHandler: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormBuilder)
